import { render, staticRenderFns } from "./capacityOfStatistical.vue?vue&type=template&id=4756acfa&scoped=true"
import script from "./capacityOfStatistical.js?vue&type=script&lang=js&external"
export * from "./capacityOfStatistical.js?vue&type=script&lang=js&external"
import style0 from "./capacityOfStatistical.vue?vue&type=style&index=0&id=4756acfa&prod&lang=scss&scoped=true"
import style1 from "./capacityOfStatistical.vue?vue&type=style&index=1&id=4756acfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4756acfa",
  null
  
)

export default component.exports